import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import axios from 'config/axios';
import Table from 'components/Table';
import { MdDateRange } from "react-icons/md";
import './index.css'
import Header from 'components/Header';
import Tabs from 'components/Tabs';
import Dropdown3 from 'components/Dropdown3';

const USAGE_TYPES = ['Tests', 'Assignments']
const TEST_TYPE = {'All': 'All', 'SAT': 'Digital SAT', 'PSAT': 'Digital PSAT', 'ACT': 'Digital ACT', 'SHAT': 'Digital SHSAT', 'TSIA2': 'TSIA2', 'BCA': 'BCA', 'Paper ACT': 'Paper ACT'}

function CreditDetail(){
    const { organization, month } = useParams();
    const [tabIndex, setTabIndex] = useState(0);
    const [tests, setTests] = useState([]);
    const [assignments, setAssignments] = useState([]);
    const [testType, setTestType] = useState(TEST_TYPE['All']);

    const localTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    
    useEffect(()=>{
        axios.get(`tutors/credits/${organization}/${month}/`, {
            params: { timezone: localTimezone } 
        })
        .then(res => {
            setTests(res.data.tests);
            setAssignments(res.data.questionSets);
        })
        .catch(error=>{
            console.log(error);
        })
    }, [organization, month, testType]);

    return (
        <>
            <Helmet>
                <title>
                    Credits Detail - Test Center Admin
                </title>
            </Helmet>
            <Header
                title={month}
                prevRoutes={[{ name: 'Test Credits', path: '/credits' }]}
            />
            <div className='CreditsDetail'>
                <div className='CreditsDetail__text'>
                    <MdDateRange />
                    <p className='CreditsDetail__text_content'>{month}</p>
                </div>
                <div className='CreditsDetail__bar'>
                    <Tabs
                        tabs={USAGE_TYPES}
                        tabIndex={tabIndex}
                        onSelect={USAGE_TYPES.map((_tab, t) => (
                            () => setTabIndex(t)
                        ))}
                    />
                    {/* <p className='CreditsDetail_text_org'>{organization}</p> */}
                    {/* <div className='CreditsDetail__text'>
                        <MdDateRange />
                        <p className='CreditsDetail__text_content'>{month}</p>
                    </div> */}
                    {USAGE_TYPES[tabIndex] === 'Tests' &&
                        <Dropdown3
                            data={Object.keys(TEST_TYPE)}
                            value={testType}
                            onSelect={value => setTestType(value)}
                        />
                    }
                </div>
                {USAGE_TYPES[tabIndex] === 'Tests'
                ?   <Table
                        key={tabIndex + testType}
                        header={['Name', 'Email', 'Test', 'Test Sections', 'Score', 'Test Start Date', 'Credit']}
                        rows={tests.filter(test => TEST_TYPE[testType] === 'All' || test.testType === TEST_TYPE[testType]).map(student => {
                            return [
                                `${student.firstName} ${student.lastName}`,
                                student.email,
                                student.test,
                                student.testSection,
                                student.testType === 'Digital SAT' || student.testType === 'Digital PSAT'
                                    ? Math.floor(student.totalScore)
                                    : student.testType === 'Digital ACT' || student.testType === 'Paper ACT'
                                    ? (student.compositeScore? Math.round(student.compositeScore): '-')
                                    : student.testType === 'Digital SHSAT'
                                    ? (student.totalScore? `${Math.floor(parseInt(student.totalScore)/student.totalQuestionCount*100)}%`: '-')
                                    : student.testType === 'TSIA2'
                                    // Flat percent correct.
                                    ? (student.totalScore != null ? `${Math.round(student.totalScore)}%` : '-')
                                    : student.testType === 'BCA'
                                    ? (student.totalScore != null ? Number(student.totalScore) : '-')
                                    : '-',
                                new Date(student.testDate).toLocaleDateString(),
                                student.credits
                            ];
                        })}
                    />
                :   USAGE_TYPES[tabIndex] === 'Assignments'
                ?   <Table
                        key={tabIndex}
                        header={['Name', 'Email', 'Assignment', 'Score', 'Start Date', 'Credit']}
                        rows={assignments.map(assignment => {
                            return [
                                `${assignment.firstName} ${assignment.lastName}`,
                                assignment.email,
                                assignment.name,
                                assignment.score,
                                new Date(assignment.startDate).toLocaleDateString(),
                                assignment.credits
                            ];
                        })}
                    />
                :   <></>
                }
                
            </div>
        </>
    )
}

export default CreditDetail